const initialState = {
  pending: null,
  id: null,
  duration: null,
  stepLength: null,
  startTrackTime: null,
  selectedStartFrame: null,
  selectedEndFrame: null,
  hasCoordinates: false,
  data: {}
};

export default function track(state = initialState, action) {
  switch (action.type) {
    case 'GET_TRACK_START':
      return { ...state,
        ...{
          pending: true,
          id: action.payload.trackId
        }
      };
    case 'GET_TRACK_COMPLETE':
      return { ...state,
        ...{
          pending: false,
          duration: action.payload.response.duration,
          stepLength: action.payload.response.stepLength,
          startTrackTime: action.payload.response.startTrackTime,
          selectedStartFrame: 0,
          selectedEndFrame: action.payload.response.duration,
          hasCoordinates: action.payload.response.hasCoordinates,
          data: action.payload.response.data,
        }
      };
    case 'GET_TRACK_FAIL':
      return {
        ...initialState
      };
    case 'CHANGE_SELECTED_START_FRAME':
      return { ...state,
        ...{ selectedStartFrame: action.payload }
      };
    case 'CHANGE_SELECTED_END_FRAME':
      return { ...state,
        ...{ selectedEndFrame: action.payload }
      };
    default:
      return state;
  }
}
